import { render } from "./barChart.vue?vue&type=template&id=4bfe0d24&scoped=true&ts=true"
import script from "./barChart.vue?vue&type=script&lang=ts"
export * from "./barChart.vue?vue&type=script&lang=ts"

import "./barChart.vue?vue&type=style&index=0&id=4bfe0d24&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfe0d24"]])

export default __exports__